<ion-content class="bg-color ion-content details-catalog">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let list of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ list.url }}">
            {{ list.label }}
          </a>
        </li>
      </ul>
    </div>

    <div class="content-grid">
      <div class="m-content">
        <form [formGroup]="apiCatalogForm">
          <mat-card>
            <mat-card-title class="mc-title">
              <h4 class="mat-title-header">Catalog</h4>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">
                <div class="form-layout">
                  <div class="form-layout-view">
                    <mat-label>Category</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="api_category" matInput>
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                    <mat-label>Brand</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="api_brand" matInput>
                    </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                    <mat-label>Price & Deals</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="api_price" matInput>
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                    <mat-label>Type</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="api_type" matInput>
                    </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                    <mat-label>Commerce</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="api_commerce" matInput placeholder="Commerce">
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                    <mat-label>Product Name</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="api_product_name" matInput placeholder="Product name">
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-layout full">
                  <mat-label>Business Objects</mat-label>
                  <mat-form-field class="example-chip-list" appearance="fill">
                    <input type="text" formControlName="api_business_object" matInput placeholder="Business object">
                  </mat-form-field>
                </div>
                <div class="form-layout full">
                  <mat-label>Workflow Status</mat-label>
                  <mat-form-field appearance="fill">
                    <input type="text" formControlName="workflow_status" matInput placeholder="Workflow Status">
                  </mat-form-field>
                </div>
                <div class="form-layout full">
                  <mat-label>Description</mat-label>
                  <mat-form-field appearance="fill">
                    <textarea formControlName="api_description" matInput cdkTextareaAutosize
                      placeholder="Description"></textarea>
                  </mat-form-field>
                </div>
                <div class="form-layout">
                  <div class="image-layout">
                    <div class="image">
                      <img [src]="imagePath">
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="m-card-main-content margin-top-10">
            <div class="m-body">
              <div class="views-content-data">
                <div class="data-options-view">
                  <mat-form-field class="data-options-dropdown-view" appearance="fill">
                    <input type="text" matInput formControlName="api_endpoint_method">
                  </mat-form-field>
                </div>
                <div class="data-url-view">
                  <mat-form-field class="data-url-view" appearance="fill">
                    <textarea class="input-url-view" rows="1" matInput placeholder="Request URL"
                      formControlName="api_endpoint_url" id="api_endpoint_url"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                (selectedTabChange)="postmanTabChange($event)">
                <mat-tab label="Params" *ngIf="catalogparamsFlag">
                  <mat-card class="mat-section">
                    <div class="m-body">
                      <div class="data-options-wrapper">
                        <div class="data-options-grid" formArrayName="api_endpoint_params_raw"
                          *ngFor="let params of params?.controls;let i = index">
                          <ng-container [formGroupName]="i">
                            <mat-form-field appearance="fill">
                              <input type="text" formControlName="paramKey" matInput placeholder="Key">
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                              <input type="text" formControlName="paramValue" matInput placeholder="Value">
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                              <input type="text" formControlName="paramDescription" matInput placeholder="Description">
                            </mat-form-field>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Authorization">
                  <mat-card class="mat-section">
                    <div class="m-body">
                      <div class="authentication-view">
                        <div class="view-options-drop">
                          <mat-label>Type</mat-label>
                          <mat-form-field class="mat-dropdown" appearance="fill">
                            <input type="text" matInput formControlName="api_endpoint_authentication_type">
                          </mat-form-field>
                        </div>
                        <div class="view-body">
                          <ng-container *ngIf="selectType == 3">
                            <div class="view-options">
                              <mat-label>Token</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Token" formControlName="authentication_token">
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectType == 4">
                            <div class="view-options">
                              <mat-label>Username</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Username"
                                  formControlName="authentication_username">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Password</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Password"
                                  formControlName="authentication_password">
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectType == 6">
                            <div class="view-options-drop">
                              <mat-label>Refresh Token Endpoint Method</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Refresh Token Endpoint Method"
                                  formControlName="oauth_refresh_token_endpoint_method">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Refresh Token Endpoint URL</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Refresh Token Endpoint URL"
                                  formControlName="oauth_refresh_token_endpoint_url">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Refresh Token Endpoint Header</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Refresh Token Endpoint Header"
                                  formControlName="oauth_refresh_token_endpoint_header">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Refresh Token Endpoint Params</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Refresh Token Endpoint Params"
                                  formControlName="oauth_refresh_token_endpoint_params">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Refresh Token Endpoint Body</mat-label>
                              <mat-form-field style="width: 100%;" appearance="fill">
                                <textarea matInput cdkTextareaAutosize rows="5" placeholder="Body"
                                  formControlName="oauth_refresh_token_endpoint_body"></textarea>
                              </mat-form-field>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Headers" *ngIf="catalogheadersFlag">
                  <mat-card class="mat-section">
                    <div class="m-body">
                      <div class="data-options-wrapper">
                        <div class="data-options-grid" formArrayName="api_endpoint_headers"
                          *ngFor="let headers of headers?.controls;let i = index">
                          <ng-container [formGroupName]="i">
                            <mat-form-field appearance="fill">
                              <input type="text" formControlName="headerKey" matInput placeholder="Key">
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                              <input type="text" formControlName="headerValue" matInput placeholder="Value">
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                              <input type="text" formControlName="headerDescription" matInput placeholder="Description">
                            </mat-form-field>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Body">
                  <mat-card class="mat-section">
                    <div class="m-body">
                      <json-editor class="disable-json" formControlName="api_endpoint_body_raw"
                        [options]="editorOptions">
                      </json-editor>
                    </div>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Pre-request Script">
                  <mat-card class="mat-section">
                    <div class="m-body-script">
                      <!-- <mat-form-field style="width: 100%;" appearance="outline">
                        <textarea cdkTextareaAutosize formControlName="pre_request_script" matInput rows="25" cols="40"></textarea>
                      </mat-form-field> -->
                      <!-- <ngx-monaco-editor formControlName="pre_request_script" [options]="editorOptions2" (init)="editorInit($event)">
                      </ngx-monaco-editor> -->
                      <ngx-codemirror formControlName="pre_request_script" #preRequestScriptEditor
                        [options]="preRequestScriptEditorOptions" (cursorActivity)="cursorMoved()">
                      </ngx-codemirror>
                    </div>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Pagination" *ngIf="catalogObj?.type?.name == 'Data Source'">
                  <mat-card class="mat-section">
                    <div class="m-body">
                      <div class="authentication-view">
                        <div class="view-options">
                          <mat-label>Select Type</mat-label>
                          <mat-form-field class="mat-dropdown" appearance="fill">
                            <input type="text" matInput formControlName="bridge_source_pagination_type">
                          </mat-form-field>
                        </div>
                        <div class="view-body">
                          <ng-container *ngIf="selectPaginationType == 2">
                            <div class="view-options">
                              <mat-label>User Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_2"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Data Collection Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_2" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Another Response Parameter</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Offset Key"
                                  formControlName="another_response_parameter_2">
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 3">
                            <div class="view-options">
                              <mat-label>User Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_3"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Key Name to Update</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Key Name to Update"
                                  formControlName="key_name_to_update_3" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Data Collection Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_3" required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 4">
                            <div class="view-options">
                              <mat-label>User Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_4"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Key Name to Update</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Key Name to Update"
                                  formControlName="key_name_to_update_4" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Data Collection Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_4" required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 5">
                            <div class="view-options">
                              <mat-label>User Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_5"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Key Name to Update</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="Key Name to Update"
                                  formControlName="key_name_to_update_5" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Data Collection Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_5" required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 6">
                            <div class="view-options">
                              <mat-label>User Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_6"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>User Key URL</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key URL" formControlName="user_key_url_6"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Data Collection Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_6" required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 7">
                            <div class="view-options">
                              <mat-label>User Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_7"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Data Collection Key</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_7" required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 8">
                            <div class="view-options">
                              <p>Custom Pagination Script</p>
                              <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                                <ngx-codemirror formControlName="custom_pagination_script" #customPaginationScriptEditor
                                  (keydown.enter)="$event.preventDefault()" [options]="codeMirrorEditorOptions">
                                </ngx-codemirror>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Numeric Params" *ngIf="catalogObj?.type?.name == 'Data Source'">
                  <mat-card class="mat-section">
                    <div class="m-body">
                      <div class="authentication-view">
                        <div class="view-body">
                          <ng-container>
                            <div class="view-options">
                              <mat-label>Minimun Number</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="number" matInput placeholder="Enter min number"
                                  formControlName="min_number" (keydown)="validateMinNum($event)">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Maximum Number</mat-label>
                              <mat-form-field appearance="fill">
                                <input type="number" matInput placeholder="Enter max number"
                                  formControlName="max_number" (keydown)="validateMaxNum($event)">
                              </mat-form-field>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </mat-tab>
              </mat-tab-group>
            </div>
          </mat-card>

          <mat-card class="margin-top-10">
            <mat-card-title class="mc-title">
              <h4 class="mat-title-header">Auditing Details</h4>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">
                <div class="list-info">
                  <span>Created By</span>
                  <span>{{catalogObj?.created_by}}</span>
                </div>
                <div class="list-info">
                  <span>Updated By</span>
                  <span>{{catalogObj?.updated_by}}</span>
                </div>
                <div class="list-info">
                  <span>Created Date</span>
                  <span>{{catalogObj?.created_date | date: 'medium'}}</span>
                </div>
                <div class="list-info">
                  <span>Updated Date</span>
                  <span>{{catalogObj?.updated_date | date: 'medium'}}</span>
                </div>
                <div class="list-info">
                  <span>Created IP Address</span>
                  <span>{{catalogObj?.created_ip_address}}</span>
                </div>
                <div class="list-info">
                  <span>Updated IP Address</span>
                  <span>{{catalogObj?.updated_ip_address}}</span>
                </div>
                <div class="btn-signup-grid">
                  <button mat-raised-button type="submit" routerLink="/baseapp/api-catalog/view"
                    class="btn btn-signup">Go Back</button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>
      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>

    <app-footer></app-footer>
  </div>
</ion-content>